module.exports = __webpack_public_path__ + "static/dhanapillai1-586cc9b6f2a831187cc4892ad9f563ee.jpg";